module.exports = __webpack_public_path__ + "static/img/pop_bg_left.4915038.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/pop_bg_left.png
// module id = vVKg
// module chunks = 2